import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Compass, Users, Plus, Route as RouteIcon, MoreHorizontal } from "lucide-react";
import { QuickActionSheet } from "./QuickActionSheet";
import { MoreSheet } from "./MoreSheet";
import { hasOwnBottomBar } from "@/lib/mobile";

const TABS = [
  { to: "/terrain", key: "terrain", label: "Terrain", icon: Compass },
  { to: "/clients", key: "clients", label: "Clients", icon: Users },
  { key: "plus", label: "Nouveau", icon: Plus, center: true },
  { to: "/tournee", key: "tournee", label: "Tournée", icon: RouteIcon },
  { key: "more", label: "Plus", icon: MoreHorizontal },
];

/** Barre du bas mobile : Terrain · Clients · + · Tournée · Plus (M1). */
export function BottomNav() {
  const loc = useLocation();
  const nav = useNavigate();
  const [quick, setQuick] = useState(false);
  const [more, setMore] = useState(false);
  if (hasOwnBottomBar(loc.pathname)) return null;
  const isActive = (to) => to && (loc.pathname === to || (to !== "/" && loc.pathname.startsWith(to + "/")));
  const onTap = (tab) => {
    if (tab.key === "plus") return setQuick(true);
    if (tab.key === "more") return setMore(true);
    nav(tab.to);
  };
  return (
    <>
      <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-5 items-end pb-safe border-t-2" style={{ background: "var(--ds-bg-surface)", borderColor: "var(--ds-text-primary)" }}
        data-testid="mobile-bottom-nav" aria-label="Navigation rapide">
        {TABS.map((tab) => {
          const active = isActive(tab.to);
          const Icon = tab.icon;
          if (tab.center) {
            return (
              <button key={tab.key} type="button" onClick={() => onTap(tab)} aria-label="Nouveau : visite, commande, prospect, note vocale" data-testid="nav-mobile-plus"
                className="flex flex-col items-center justify-end min-h-[64px] pb-1">
                <span className="w-14 h-14 -mt-6 rounded-full flex items-center justify-center tap-scale border-2" style={{ background: "var(--ds-brand-coral)", color: "var(--ds-bg-elevated)", borderColor: "var(--ds-text-primary)", boxShadow: "3px 3px 0 0 var(--ds-text-primary)" }}><Icon size={30} strokeWidth={2.5} aria-hidden="true" /></span>
              </button>
            );
          }
          return (
            <button key={tab.key} type="button" onClick={() => onTap(tab)} data-testid={`nav-mobile-${tab.key}`} aria-label={tab.label}
              aria-current={active ? "page" : undefined}
              className="flex flex-col items-center justify-center gap-0.5 min-h-[64px] tap-scale" style={{ color: active ? "var(--ds-accent)" : "var(--ds-text-secondary)" }}>
              <Icon size={24} strokeWidth={active ? 2.25 : 1.75} aria-hidden="true" />
              <span className={`text-xs ${active ? "font-bold" : "font-medium"}`}>{tab.label}</span>
              {active && <span className="w-1.5 h-1.5 rounded-full" style={{ background: "var(--ds-brand-coral)" }} aria-hidden="true" />}
            </button>
          );
        })}
      </nav>
      <QuickActionSheet open={quick} onClose={() => setQuick(false)} />
      <MoreSheet open={more} onClose={() => setMore(false)} />
    </>
  );
}
